export default {
  de: {
    searchPlaceholder: "Stelle suchen...",
    resetFilters: "Filter zurücksetzen",
    submitFilters: "Suchen",
    noJobs: "Keine passende Stelle gefunden",
    jobaboButtonLabel: "Job-Abo einrichten",
    jobaboModalButtonLabel: "Diese Suche abonnieren",
    filterBerufsgruppeLabel: "Berufsgruppe",
    filterKlinikBereichLabel: "Klinik / Bereich",
    filterArbeitsortLabel: "Arbeitsort",
    jobaboEmailLabel: "Email",
    jobaboNameLabel: "Bezeichnung",
    jobaboSubscriptionFormTitle: "Job-Abo",
    jobaboSubscriptionFormText:
        "Wollen Sie regelmässig über neue Stellenangebote bei den Psychiatrischen Diensten Aargau (PDAG) informiert werden? Eröffnen Sie Ihr persönliches Job-Abo und Sie werden via E-Mail automatisch über passende Stellen informiert.",
    awardsLabel: "Unsere Erfolge und Auszeichnungen",
    gender: "m/w/d",
    homeoffice: "Homeoffice Möglichkeit",
    spontanbewerbung: "Spontanbewerbung",
    workloadLabel: "Pensum:"
  },

  fr: {
    searchPlaceholder: "Aller à",
    resetFilters: "Mettre à jour",
    submitFilters: "Recherche par mot-clé",
    noJobs: "Pas d'emploi correspondant",
    jobaboButtonLabel: "Configurer Job Abo",
    jobaboModalButtonLabel: "S'abonner à cette recherche",
    filterStandortLabel: "Lieu",
    filterArbeitsbereichLabel: "Secteur d'activité",
    filterVertragsartLabel: "Categorie de poste",
    jobaboEmailLabel: "Email",
    jobaboNameLabel: "Désignation",
    jobaboSubscriptionFormTitle: "Job-Abo",
    jobaboSubscriptionFormText:
        "Souhaitez-vous recevoir régulièrement des informations sur les nouveaux postes chez Holcim ? Ouvrez votre profil de recherche individuel et vous serez automatiquement informé des postes vacants appropriés.",
    awardsLabel: "Nos succès et nos récompenses",
    gender: "m/w/d",
    homeoffice: "Possibilité de travailler à domicile",
    spontanbewerbung: "Candidature spontanée",
  },

  it: {
    searchPlaceholder: "Ricerca",
    resetFilters: "Aggiorna",
    submitFilters: "Ricerca per parole chiave",
    noJobs: "Non è stata trovata una posizione adatta",
    jobaboButtonLabel: "Iscriviti a questa ricerca",
    jobaboModalButtonLabel: "Iscriviti a questa ricerca",
    filterStandortLabel: "Posizione",
    filterArbeitsbereichLabel: "Area di lavoro",
    filterVertragsartLabel: "Categoria di posto",
    jobaboEmailLabel: "Email",
    jobaboNameLabel: "Designazione",
    jobaboSubscriptionFormTitle: "Job-Abo",
    jobaboSubscriptionFormText:
        "Desiderate ricevere regolarmente informazioni sulle nuove posizioni in Holcim? Aprite il vostro profilo di ricerca individuale e sarete automaticamente informati sulle offerte di lavoro adeguate.",
    awardsLabel: "I nostri successi e riconoscimenti",
    gender: "m/w/d",
    homeoffice: "Possibilità di ufficio in casa",
    spontanbewerbung: "Applicazione spontanea",
  },

  en: {
    searchPlaceholder: "Search term",
    resetFilters: "Reset filters",
    submitFilters: "Search",
    noJobs: "No jobs found",
    jobaboButtonLabel: "Subscribe to Job-Newsletter",
    jobaboModalButtonLabel: "Subscribe to this search",
    filterStandortLabel: "Location",
    filterArbeitsbereichLabel: "Occupational area",
    filterVertragsartLabel: "Contract type",
    jobaboEmailLabel: "Email",
    jobaboNameLabel: "Subscription name",
    jobaboSubscriptionFormTitle: "Subscribe to new jobs",
    jobaboSubscriptionFormText:
      "Do you want to be informed regularly about new vacancies at Holcim (Schweiz) AG? Open your individual job search profile and be informed automatically about suitable jobs.",
    awardsLabel: "Our successes and awards",
    gender: "m/w/d",
    homeoffice: "Homeoffice possible",
    spontanbewerbung: "Unsolicited application",
  },
};
